"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindingSchema = exports.FreeformFindingSchema = exports.NetDriveFindingSchema = exports.BaseFindingSchema = exports.FindingDesignObjectTagSchema = exports.FindingStatusSchema = exports.FindingStatus = exports.FindingTypeSchema = exports.FindingType = void 0;
const zod_1 = require("zod");
const Claim_1 = require("../../Claim/types/Claim");
const RequirementInstanceResult_1 = require("../../Requirements/types/RequirementInstanceResult");
const DesignObject_1 = require("../../Requirements/types/DesignObject");
var FindingType;
(function (FindingType) {
    FindingType["Freeform"] = "FreeformFinding";
    FindingType["NetDrive"] = "NetDriveFinding";
})(FindingType || (exports.FindingType = FindingType = {}));
exports.FindingTypeSchema = zod_1.z.nativeEnum(FindingType);
var FindingStatus;
(function (FindingStatus) {
    FindingStatus["Success"] = "success";
    FindingStatus["Recommendation"] = "recommendation";
    FindingStatus["Warning"] = "warning";
    FindingStatus["Error"] = "error";
})(FindingStatus || (exports.FindingStatus = FindingStatus = {}));
exports.FindingStatusSchema = zod_1.z.nativeEnum(FindingStatus);
exports.FindingDesignObjectTagSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: DesignObject_1.DesignObjectTypeSchema,
    reference: zod_1.z.string(),
});
exports.BaseFindingSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: exports.FindingTypeSchema,
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string().optional(),
    status: exports.FindingStatusSchema,
    isReviewed: zod_1.z.boolean(),
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    designObjectTags: exports.FindingDesignObjectTagSchema.array(),
    analysisResults: RequirementInstanceResult_1.RequirementInstanceResultSchema.array().optional(),
});
exports.NetDriveFindingSchema = exports.BaseFindingSchema.extend({
    type: zod_1.z.literal(FindingType.NetDrive),
    requirementResultIds: zod_1.z.string().array().optional(),
    sources: Claim_1.ClaimSchema.array(),
    sinks: Claim_1.ClaimSchema.array(),
    connections: Claim_1.ClaimSchema.array(),
});
exports.FreeformFindingSchema = exports.BaseFindingSchema.extend({
    type: zod_1.z.literal(FindingType.Freeform),
    claims: Claim_1.ClaimSchema.array(),
});
exports.FindingSchema = zod_1.z.discriminatedUnion('type', [
    exports.NetDriveFindingSchema,
    exports.FreeformFindingSchema,
]);
//# sourceMappingURL=Finding.js.map